/**
 * Recently Viewed Products - EVSTORE
 * Tracks viewed products in localStorage, renders in section.
 * Fetches each product individually via /products/{handle}.js
 * to avoid downloading the entire catalog.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'evstore_recently_viewed';
    var MAX_ITEMS = 12;

    function run() {
        // Track current product
        var productPage = document.querySelector('[data-product-page]');
        if (productPage) {
            var productId = productPage.dataset.productId;
            var productHandle = productPage.dataset.productHandle;
            if (productId && productHandle) {
                trackProduct(productId, productHandle);
            }
        }

        // Render recently viewed sections
        var sections = document.querySelectorAll('[data-recently-viewed]');
        if (sections.length > 0) {
            var viewed = getViewed();
            if (viewed.length > 0) {
                sections.forEach(function (section) {
                    var limit = parseInt(section.dataset.recentlyViewedLimit) || 4;
                    var exclude = section.dataset.recentlyViewedExclude || '';
                    var items = viewed.filter(function (item) { return item.id !== exclude; }).slice(0, limit);

                    if (items.length === 0) {
                        section.style.display = 'none';
                        return;
                    }

                    fetchProducts(items, function (products) {
                        renderProducts(section, products);
                    });
                });
            } else {
                sections.forEach(function (s) { s.style.display = 'none'; });
            }
        }
    }

    if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 2000 });
    } else {
        setTimeout(run, 200);
    }

    function trackProduct(id, handle) {
        var viewed = getViewed();
        viewed = viewed.filter(function (item) { return item.id !== id; });
        viewed.unshift({ id: id, handle: handle });
        if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
        } catch (e) { /* quota exceeded - ignore */ }
    }

    function getViewed() {
        try {
            var data = localStorage.getItem(STORAGE_KEY);
            if (!data) return [];
            var parsed = JSON.parse(data);
            return parsed.filter(function (item) {
                return item && typeof item === 'object' && item.id && item.handle;
            });
        } catch (e) {
            return [];
        }
    }

    function fetchProducts(items, callback) {
        var promises = items.map(function (item) {
            return fetch('/products/' + item.handle + '.js')
                .then(function (r) {
                    if (!r.ok) return null;
                    return r.json();
                })
                .catch(function () { return null; });
        });

        Promise.all(promises).then(function (products) {
            callback(products.filter(Boolean));
        });
    }

    function renderProducts(section, products) {
        if (products.length === 0) {
            section.style.display = 'none';
            return;
        }

        var grid = section.querySelector('[data-recently-viewed-grid]');
        if (!grid) return;

        section.style.display = '';

        var localeRoot = (section.dataset.localeRoot || '').replace(/\/$/, '');

        var html = '';
        products.forEach(function (product) {
            var imageUrl = product.images && product.images.length > 0 ? product.images[0] : '';
            var priceCents = product.variants[0] ? product.variants[0].price : 0;
            var comparePriceCents = product.variants[0] ? product.variants[0].compare_at_price : null;
            var available = product.variants[0] ? product.variants[0].available : false;

            var formatPrice = function (cents) {
                var amount = (cents / 100).toFixed(2);
                var parts = amount.split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                return parts[0] + ',' + parts[1];
            };

            html += '<article class="product-card product-card--standard">';
            html += '<a href="' + localeRoot + '/products/' + product.handle + '" class="product-card__link">';
            html += '<div class="product-card__image-wrapper">';
            if (imageUrl) {
                html += '<img src="' + imageUrl.replace(/\.([a-z]+)(\?.*)?$/, '_600x.$1') + '" alt="' + escapeHtml(product.title) + '" class="product-card__image product-card__image--primary" loading="lazy">';
            }
            if (!available) {
                html += '<div class="product-card__badges"><span class="product-card__badge product-card__badge--soldout">Esaurito</span></div>';
            } else if (comparePriceCents && comparePriceCents > priceCents) {
                var pct = Math.round((1 - priceCents / comparePriceCents) * 100);
                html += '<div class="product-card__badges"><span class="product-card__badge product-card__badge--sale">-' + pct + '%</span></div>';
            }
            html += '</div>';
            html += '<div class="product-card__content">';
            if (product.vendor) {
                html += '<span class="product-card__vendor">' + escapeHtml(product.vendor) + '</span>';
            }
            html += '<h3 class="product-card__title">' + escapeHtml(product.title) + '</h3>';
            html += '<div class="product-card__pricing">';
            html += '<span class="product-card__price">€' + formatPrice(priceCents) + '</span>';
            if (comparePriceCents && comparePriceCents > priceCents) {
                html += '<span class="product-card__price-compare">€' + formatPrice(comparePriceCents) + '</span>';
            }
            html += '</div>';
            html += '</div>';
            html += '</a>';
            html += '</article>';
        });

        grid.innerHTML = html;
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
    }
})();
